__turbopack_context__.v({
  "cardlist": "index-module-scss-module__hL5KSq__cardlist",
  "grid": "index-module-scss-module__hL5KSq__grid",
  "loading": "index-module-scss-module__hL5KSq__loading",
  "pagination": "index-module-scss-module__hL5KSq__pagination",
  "skeletonCard": "index-module-scss-module__hL5KSq__skeletonCard",
  "skeletonContent": "index-module-scss-module__hL5KSq__skeletonContent",
  "skeletonMeta": "index-module-scss-module__hL5KSq__skeletonMeta",
  "skeletonThumbnail": "index-module-scss-module__hL5KSq__skeletonThumbnail",
  "skeletonTitle": "index-module-scss-module__hL5KSq__skeletonTitle",
});
